import React from 'react';
import PropTypes from 'prop-types';

export default function InputRequired(props) {
  return (<span>{props.name} <span className="color-required">*</span></span>);
}

InputRequired.propTypes = {
  name: PropTypes.string.isRequired
};
